// extracted by mini-css-extract-plugin
export default {"rating":"uG-z","numberOfStars":"vG-z","count":"wG-z","barGraphSpacing":"xG-z","barGraph":"yG-z"};